import BaseService from '@src/services/BaseService'

class PermissionService extends BaseService {
  constructor() {
    super('permissions')
  }
}

export default new PermissionService()
